import React from 'react';
import {IconButton, Tooltip} from '@material-ui/core';
import SyncIcon from '@material-ui/icons/Sync';

interface ReloadIconProps {
  title: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  fontSize?: 'small' | 'inherit' | 'default' | 'large';
  className?: string;
  dataTestId?: string;
}
const ReloadIcon = (props: ReloadIconProps): React.ReactElement => {
  const {
    title,
    onClick,
    disabled,
    fontSize,
    className = '',
    dataTestId = ''
  } = props;
  return (
    <Tooltip title={title}>
      <IconButton
        className={`reloadIcon ${className}`}
        onClick={onClick}
        disabled={disabled}
        data-test-id={dataTestId}>
        <SyncIcon fontSize={fontSize} />
      </IconButton>
    </Tooltip>
  );
};

export default ReloadIcon;
